import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import callApi from './helpers/callapi';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import { getTheme, viewportWidth } from 'helpers/helpers';
import { Route, Switch, Redirect, useLocation, useHistory, Link } from 'react-router-dom';

import AdminList from 'containers/Admin/List';
import cn from 'classnames';
// import UserList from 'containers/User/List';

import Dashboard from 'containers/Dashboard';
// import AdminDashboard from 'containers/Dashboard/Admin';

import EnrollmentList from 'containers/Enrollment/List';

import StudentExamList from 'containers/Student/Exam-List';

import Stat from 'containers/Stat/Stat';

import Help from 'containers/Help';
import Contact from 'containers/Contact';

// Containers

// import 'react-big-calendar/lib/css/react-big-calendar.css';

// Components
import { Spin, Modal, Select } from 'antd';
import { UserOutlined, SettingOutlined, BarsOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import { useIdleTimer } from 'react-idle-timer';

// menus
import menus from './configs/menus';

const Option = Select.Option;

moment.locale('th');
const MOBILE_MENU_WIDTH = 240;

const notRedirectToLoginPaths = ['/reset-password', '/login', '/forgot-password'];

export default function () {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [smallNav, setNav] = useState(false);

  const [isLogoutModalShow, setIsLogoutModalShow] = useState(false);
  const adminConfig = useSelector((state) => state.configs || {});

  const year = useSelector((state) => state.year || '');

  const handleOnIdle = (event) => {
    if (location.pathname === '/login') return null;
    if (location.pathname === '/reset-password') return null;

    setIsLogoutModalShow(true);

    if (!isLogoutModalShow) {
      const accessToken = Cookies.get('accessToken');
      Cookies.remove('accessToken');
      Modal.warning({
        title: '',
        content: (
          <div>
            ท่านไม่ได้ดำเนินการใด ๆ ในระบบเป็นเวลา 10 นาที ท่านจะถูก log off โดยอัตโนมัติ ถ้าท่านต้องการใช้งาน กรุณา
            login อีกครั้ง
          </div>
        ),
        onOk() {
          Cookies.set('accessToken', accessToken);
          setIsLogoutModalShow(false);
          _onLogout();
        },
        cancelButtonProps: <span></span>,
      });
    }
  };

  const handleOnActive = (event) => {
    if (location.pathname === '/login') return null;
    if (location.pathname === '/reset-password') return null;

    const accessToken = Cookies.get('accessToken');
    if (accessToken) {
      Cookies.set('accessToken', accessToken, {
        expires: 1 / (24 * 6),
      });
    }
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 10,
    onIdle: handleOnIdle,
    // onActive: handleOnActive,
    onAction: handleOnActive,
    debounce: 500,
  });

  const handleNav = () => {
    setNav(!smallNav);
  };

  const [currentAdmin, setCurrentAdmin] = useState();
  const [ticketCount, setCountTicket] = useState(0);

  useEffect(() => {
    const getAdminConfig = async () => {
      const configs = await callApi({ url: '/configs/admin' });
      dispatch({ type: 'UPDATE_CONFIGS', data: configs });

      dispatch({ type: 'UPDATE_YEAR', data: configs.current_year });
    };
    const verify = async () => {
      try {
        const me = await callApi({ url: '/users/me' });

        dispatch({ type: 'UPDATE_USER', data: me });

        setCurrentAdmin(me);
        await getAdminConfig();
      } catch (error) {
        // Cookies.remove('accessToken');
        dispatch({ type: 'UPDATE_USER', data: null });
        if (notRedirectToLoginPaths.indexOf(location.pathname) === -1) {
          // console.log('check');
          window.location.href = 'https://mytcas.com';
        }
      }
    };
    verify();
  }, []);

  const [loggingOut, setLoggingOut] = useState(false);
  const _onLogout = async () => {
    if (loggingOut) return;
    try {
      setLoading(true);
      setLoggingOut(true);
      await callApi({
        method: 'POST',
        url: '/users/logout',
      });

      Cookies.remove('accessToken');
      window.location.href = '/login';
      setLoggingOut(false);
    } catch (error) {
      console.error('Error while trying to log out.', error);
      window.location.href = '/login';
      setLoggingOut(false);
    }
  };

  if (location.pathname === '/login') return null;
  if (location.pathname === '/reset-password') return null;
  if (!currentAdmin) return null;

  if (!Cookies.get('accessToken')) {
    // window.location.href = 'https://mytcas.com';
    return null;
  }

  const checkMenuVisibleFromConfig = (configVisibleField) => {
    if (configVisibleField) {
      if (configVisibleField.startsWith('!')) {
        return !adminConfig[_.trim(configVisibleField, '!')];
      }
      return adminConfig[configVisibleField];
    }
    return true;
  };

  return (
    <section className={smallNav ? 'small-nav' : null}>
      <Spin spinning={loading}>
        <div>
          {location.pathname !== '/login' && (
            <div className="t-head">
              <div className="t-head-school">
                <div className="year-info">
                  <Select
                    value={year}
                    onChange={(value) => {
                      dispatch({ type: 'UPDATE_YEAR', data: value });
                    }}
                  >
                    {(adminConfig.years || []).map((yearOption, i) => {
                      return (
                        <Option key={i} value={`${yearOption}`}>
                          ปี {yearOption}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
                {currentAdmin.role === 'school' && <h3>{_.get(currentAdmin, 'school.name')}</h3>}
              </div>
              <ul className="t-user">
                <li className="info">
                  <a>
                    {currentAdmin && (currentAdmin.name || currentAdmin.email)}
                    <b>{currentAdmin && currentAdmin.role === 'super' && '• ผู้ดูแลระบบ'}</b>
                  </a>
                </li>
                <li>
                  <a className="btn-gray" style={{ cursor: 'pointer' }} onClick={_onLogout}>
                    ออกจากระบบ
                  </a>
                </li>
              </ul>
            </div>
          )}
          <div className="t-body">
            <div className="t-side">
              <ul className="t-nav">
                <li className="m-home">
                  <Link to="/dashboard">
                    <img src="/img/logo.svg" alt="Logo" width="118" height="45" />
                    <b>โรงเรียน</b>
                  </Link>
                </li>
                {currentAdmin &&
                  menus.map((menu) => {
                    let { key, to, title, roles = [], submenus = [] } = menu;
                    const currentRole = currentAdmin.role;
                    const isActive =
                      location.pathname === to ||
                      submenus.reduce((result, submenu) => {
                        result = result || location.pathname === submenu.to;
                        return result;
                      }, false);

                    if (roles.length === 0 || roles.indexOf(currentRole) > -1) {
                      return (
                        <li className={cn({ active: isActive }, key)} key={key}>
                          {
                            <Link to={to}>
                              <i className={key}></i>
                              <span>{title}</span>
                              {key === 'tickets' && ticketCount > 0 && <b className="noti">{ticketCount}</b>}
                            </Link>
                          }

                          {Boolean(submenus.length) && isActive && (
                            <ul className="sub">
                              {submenus.map(({ to, title, key, roles = [], configVisibleField }) => {
                                if (
                                  (roles.length === 0 || roles.indexOf(currentRole) > -1) &&
                                  checkMenuVisibleFromConfig(configVisibleField)
                                ) {
                                  return (
                                    <li
                                      className={cn(
                                        {
                                          active: location.pathname === to,
                                        },
                                        key
                                      )}
                                      key={key}
                                    >
                                      <Link to={to}>
                                        <i className={key}></i>
                                        <span>{title}</span>
                                      </Link>
                                    </li>
                                  );
                                }
                                return null;
                              })}
                            </ul>
                          )}
                        </li>
                      );
                    }
                    return <div key={key}></div>;
                  })}

                <li className="m-collapse">
                  <a onClick={handleNav}>
                    <i className="collapse"></i>
                    <span>ย่อเมนู</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="t-content">
              <Switch>
                <Route
                  exact
                  path="/dashboard"
                  render={() => {
                    return get(currentAdmin, 'role') === 'school' ? <Dashboard /> : <Dashboard />;
                  }}
                />

                <Route exact path="/students/exams" component={StudentExamList} />
                <Route exact path="/students/enrollments" component={EnrollmentList} />

                <Route exact path="/stats" component={Stat} />

                <Route exact path="/users" component={AdminList} />

                <Route exact path="/help" component={Help} />

                <Route exact path="/contact" component={Contact} />

                {/* <Redirect to="/login" /> */}
              </Switch>
            </div>
          </div>
        </div>
      </Spin>
    </section>
  );
}
